module.exports = __webpack_public_path__ + "img/default-template-img.ce6bc4e8.svg";